import React, { Component } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { selectOffice } from 'actions/user-companies/select';
import { retrieve, reset } from 'actions/office-settings/show';
import { retrieve as retrieveOffice } from 'actions/office/show';
import { Dimmer, Loader, Segment } from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';

import ShowContactInformation from './show';
import EditContactInformation from './edit';
import NotFound from '../../../404';

class ContactInformation extends Component {
  componentDidMount() {
    const { selectedOffice, selectOffice, getSettings, getOffice, match } = this.props;

    if ((selectedOffice && selectedOffice.id !== Number(match.params.id)) || !selectedOffice) {
      selectOffice(null);
      getOffice(`/offices/${match.params.id}`);
    } else {
      getSettings(`/office_settings?office=${selectedOffice.id}&name=CONTACT_INFORMATION`);
    }
  }

  componentDidUpdate(prevProps) {
    const {
      updated,
      retrievedOffice,
      selectedOffice,
      getSettings,
      selectOffice,
      match,
    } = this.props;

    if (!isEmpty(updated) && updated !== prevProps.updated) {
      getSettings(`/office_settings?office=${selectedOffice.id}&name=CONTACT_INFORMATION`);
    }

    if (!isEmpty(retrievedOffice) && !selectedOffice) {
      getSettings(`/office_settings?office=${match.params.id}&name=CONTACT_INFORMATION`);
      selectOffice(retrievedOffice);
    }
  }

  componentWillUnmount() {
    const { reset } = this.props;
    reset();
  }

  render() {
    const {
      selectedOffice,
      retrieved,
      loadingOfficeSettings,
      loadingOffice,
      office,
      t,
    } = this.props;

    if (loadingOfficeSettings || isEmpty(retrieved) || loadingOffice || isEmpty(selectedOffice)) {
      return (
        <div className="section-container">
          <Segment
            basic
            className="section-loading"
          >
            <Dimmer active={loadingOfficeSettings || loadingOffice} inverted>
              <Loader>{t('loading')}</Loader>
            </Dimmer>
          </Segment>
        </div>
      );
    }

    return (
      <Switch>
        <Route exact path="/offices/:id/settings/contact-information" component={ShowContactInformation} />
        <Route
          exact
          path="/offices/:id/settings/contact-information/edit"
          render={props => (
            <EditContactInformation {...props} office={office} />
          )}
        />
        <Route component={NotFound} />
      </Switch>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getSettings: page => dispatch(retrieve(page)),
  getOffice: page => dispatch(retrieveOffice(page)),
  selectOffice: office => dispatch(selectOffice(office)),
  reset: () => {
    dispatch(reset());
  },
});

const mapStateToProps = state => ({
  selectedOffice: state.userCompanies.select.selectedOffice,

  retrieved: state.officeSettings.show.retrieved,
  loadingOfficeSettings: state.officeSettings.list.loading,

  retrievedOffice: state.office.show.retrieved,
  loadingOffice: state.office.show.loading,

  updated: state.officeSettings.update.updated,
});

const Main = connect(mapStateToProps, mapDispatchToProps)(ContactInformation);

export default withTranslation()(withRouter(Main));
